import React, { Component } from 'react';
import { Row, Col, Media } from 'react-bootstrap';
import vlad from '../assets/vlad.jpg';
import store from '../store';
import DevView from '../_partials/dev-view';
import ViewSelect from '../_partials/view-select';

class AboutMe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutMe: {},
      experience: [],
      skills: [],
      human: true,
    };
    this.storeListener = this.storeListener.bind(this);
  }

  async UNSAFE_componentWillMount() {
    const state = store.getState();
    this.setState({ aboutMe: state.aboutMe, experience: state.experience, skills: state.skills });

    this.unsubscribeStore = store.subscribe(this.storeListener);
  }

  UNSAFE_componentWillUnmount() {
    this.unsubscribeStore();
  }

  storeListener() {
    const state = store.getState();
    this.setState({ aboutMe: state.aboutMe, experience: state.experience, skills: state.skills });

    //console.log(this.state.aboutMe);
    //console.log(this.state.experience);
    //console.log(this.state.skills);
  }

  filterProgrammingSkills(skills) {
    const prSkills = skills.filter(
      skill => skill['type'].toLowerCase() === 'programming languages',
    );
    return prSkills
      ? prSkills.map((skill, index, array) => {
          return index === array.length - 2 ? `${skill.name} and ` : `${skill.name}, `;
        })
      : '';
  }
  handleChange(viewState) {
    this.setState({ human: !viewState });
  }

  filterPastCompanies(companies) {
    return companies
      .filter(c => c.yearFinish)
      .map((company, index, array) => {
        if (index === array.length - 1) {
          return `${company.company}`;
        } else if (index === array.length - 2) {
          return `${company.company} and `;
        } else {
          return `${company.company}, `;
        }
      });
  }

  findCurrentCompany(companies) {
    return companies.find(c => !c.yearFinish);
  }

  mainInfo() {
    if (this.state.human) {
      return (
        <div className="portfolio__block__about-me--human">
          <Media>
            <img
              width={64}
              height="auto"
              className="mr-3"
              aria-hidden
              src={vlad}
              alt="Vladimir Alferov photo"
            />
            <Media.Body>
              <h3 className="greeting">Hello, dear visitor!</h3>
              <div>
                I am {this.state.aboutMe.firstName} {this.state.aboutMe.lastName}. I am a backend
                developer (mostly in {this.filterProgrammingSkills(this.state.skills)} but
                absolutely fine with learning any other language). My background is very mixed and
                not really trivial. I used to be a professional ice hockey player, played in junior
                leagues in Russia and Canada, but at some point realised that it’s not what drives
                me crazy. I like building stuff and spending time with my laptop, so I made my
                choice and switched to programming. Since then I’ve worked for different companies,
                including {this.filterPastCompanies(this.state.experience)}. Currently I’m working
                at{' '}
                {this.findCurrentCompany(this.state.experience)
                  ? this.findCurrentCompany(this.state.experience).company
                  : ''}
                .
              </div>
            </Media.Body>
          </Media>
        </div>
      );
    } else {
      return <DevView data={this.state.aboutMe} />;
    }
  }

  render() {
    return (
      <Row className="portfolio__block" id="about-me">
        <Col>
          <h3 className="portfolio__block__heading">about me</h3>
          <div className="portfolio__block__about-me">
            <ViewSelect onChange={this.handleChange.bind(this, this.state.human)} />
            <hr></hr>
            {this.mainInfo()}
          </div>
        </Col>
      </Row>
    );
  }
}

export default AboutMe;
